export default "__VITE_ASSET__C_mRQ1lL__"